/* eslint-disable react/no-array-index-key */
import 'katex/dist/katex.min.css';
import TeX from '@matejmazur/react-katex';
import parse from 'html-react-parser';

export const renderHtmlWithTeX = (question: any, shouldParse: boolean) => {
  const matchesText = question?.split('$~');
  if (matchesText && matchesText.length > 0) {
    return matchesText.map((item: any, index: number) => {
      if (index % 2 === 1) {
        // let tempString = String.raw`${item}`;
        // let res = JSON.stringify(tempString);

        return <TeX key={index}>{item}</TeX>;
      }
      return (
        <span key={index} className='mx-2'>
          {shouldParse ? parse(item) : item}
        </span>
      );
    });
  }
};
